import React from "react";
import "../styles/EmptyChannelMessage.css";
import { Button, FaIcon } from "../shared/ui";
import { faPenToSquare } from "@fortawesome/free-regular-svg-icons";

const EmptyChannelMessage = ({ setMode, mode, hasRecentUsers }) => {
  return (
    <div className="str-chat__main-panel str-chat__empty-channel">
      <div className="empty-channel-content">
        <div className="str-chat__empty-channel-text">
          {mode === "recent" ? (
            hasRecentUsers ? (
              <div>Select a user to get started chatting.</div>
            ) : (
              <>
                <div>You don’t have any messages yet.</div>
                <div>Click below to get started.</div>
              </>
            )
          ) : (
            <div>Search for users to get started.</div>
          )}
        </div>
        {mode === "recent" && !hasRecentUsers && (
          <div>
            <Button variant="secondary" onClick={() => setMode("search")}>
              <div className="w-3">
                <FaIcon icon={faPenToSquare} />
              </div>
              <span>New Chat</span>
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmptyChannelMessage;
